import { useQuery } from '@tanstack/react-query'

import { getStatuses } from '~/controllers/status'
import { CACHE_TIME_1HR, STALE_TIME_1HR } from '~/queryCache'

export const useStatusQuery = (props: { typeName: string }) => {
  const { typeName } = props;
  return useQuery(
    ['getStatus', { typeName }],
    getStatuses,
    {
      cacheTime: CACHE_TIME_1HR,
      staleTime: STALE_TIME_1HR,
      enabled: !!typeName,
    });
}
